import api from './api';
import mockApi from './mock_api';

// let apiExport = mockApi;

// if (process.env.NODE_ENV === 'production') {
let  apiExport = api;
// }

export default apiExport;



// WEBPACK FOOTER //
// ./src/utils/api/index.js